import Spinner from 'src/javascripts/components/utilities/Spinner';

// Change loading state of a button 
// Need to allow loading = true and false for ajax calls

export default function(el, isLoading) {
  let card = el.closest('.Card');

  if (isLoading) {
    card.addClass('position-relative');
    Spinner(card);
    card.find('.Card-body').css('opacity', 0.2);
    el.addClass('disabled');

  } else {
    card.removeClass('.position-relative');
    card.find('.spinner-container').remove();
    card.find('.Card-body').css('opacity', 1);
    el.removeClass('disabled');

  }

};